import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'rock',
      d: 'M0.5,-13.5h3v0.5h-3zM-3,-13h5.5v0.5h-5.5zM3,-13h0.5v0.5h-0.5zM-3.5,-12.5h3v0.5h-3zM-9,-8.5h1v0.5h-1zM8,-8.5h1v0.5h-1zM-8,-8h1v0.5h-1zM-6.5,-7.5h1v0.5h-1zM-1.5,-6h1v0.5h-1zM-2,-4.5h1v0.5h-1zM1,-4.5h1v0.5h-1zM-1.5,-4h3v4h-3zM-5.5,-2.5h0.5v0.5h-0.5zM5,-2.5h1v0.5h-1zM-6.5,-2h1.5v0.5h-1.5zM5,-2h2v0.5h-2zM-7.5,-1.5h2.5v0.5h-2.5zM5,-1.5h3v0.5h-3zM-7,-1h1.5v0.5h-1.5zM5.5,-1h2v0.5h-2zM-6,-0.5h1v0.5h-1zM-3.5,-0.5h1v0.5h-1zM2.5,-0.5h1v0.5h-1zM5,-0.5h1.5v0.5h-1.5zM-5,0h1v0.5h-1zM-3,0h6v0.5h-6zM4,0h1.5v0.5h-1.5zM-4,0.5h8v0.5h-8zM-3,1h6v0.5h-6zM-2,1.5h4v0.5h-4zM-1,2h2v0.5h-2z',
    },
    {
      paint: [
        ['rock', 0.7],
        ['shadow', 0.3],
      ],
      d: 'M2.5,-13h0.5v0.5h-0.5zM-8.5,-8h0.5v0.5h-0.5zM7,-8h1v0.5h-1zM-7,-7.5h0.5v0.5h-0.5zM5,-7.5h2v0.5h-2zM-5.5,-7h1.5v0.5h-1.5zM3.5,-7h1.5v0.5h-1.5zM-4,-6.5h2v0.5h-2zM2,-6.5h1.5v0.5h-1.5zM-2,-6h0.5v0.5h-0.5zM0.5,-6h1.5v0.5h-1.5zM-0.5,-5.5h1v0.5h-1zM-1,-4.5h0.5v0.5h-0.5zM0.5,-4.5h0.5v0.5h-0.5zM4.5,-2.5h0.5v1.5h-0.5zM-5,-2h0.5v1h-0.5zM-7.5,-1h0.5v0.5h-0.5zM-4,-1h1v0.5h-1zM3,-1h1v0.5h-1zM7.5,-1h0.5v0.5h-0.5zM-7.5,-0.5h1.5v0.5h-1.5zM-2.5,-0.5h0.5v0.5h-0.5zM2,-0.5h0.5v0.5h-0.5zM6.5,-0.5h1.5v0.5h-1.5zM-7.5,0h2.5v0.5h-2.5zM5.5,0h2.5v0.5h-2.5zM-6.5,0.5h2.5v0.5h-2.5zM4,0.5h3v0.5h-3zM-5.5,1h2.5v0.5h-2.5zM3,1h3v0.5h-3zM-4.5,1.5h2.5v0.5h-2.5zM2,1.5h3v0.5h-3zM-3.5,2h2.5v0.5h-2.5zM1,2h2.5v0.5h-2.5zM-2.5,2.5h5v0.5h-5zM-1.5,3h3v0.5h-3zM-0.5,3.5h1v0.5h-1z',
    },
    {
      paint: 'trunk',
      d: 'M-5,-6h1v0.5h-1zM4,-6h1v0.5h-1zM-5,-5.5h1.5v0.5h-1.5zM3.5,-5.5h1.5v0.5h-1.5zM-5,-5h1v2.5h-1zM4,-5h1v2.5h-1zM-4.5,-2.5h0.5v1.5h-0.5zM4,-2.5h0.5v1.5h-0.5z',
    },
    {
      paint: [
        ['shadow', 0.3],
        ['trunk', 0.7],
      ],
      d: 'M-4,-6h0.5v0.5h-0.5zM3.5,-6h0.5v0.5h-0.5zM-3,-5.5h1v0.5h-1zM2,-5.5h1v0.5h-1zM-4,-5h0.5v0.5h-0.5zM-2,-5h4v0.5h-4zM3.5,-5h0.5v0.5h-0.5zM-0.5,-4.5h1v0.5h-1z',
    },
    {
      paint: 'roofA',
      d: 'M-3.5,-5h0.5v0.5h-0.5zM3,-5h0.5v0.5h-0.5zM-4,-4.5h2v0.5h-2zM2,-4.5h2v0.5h-2zM-4,-4h1.5v1.5h-1.5zM-2,-4h0.5v4h-0.5zM1.5,-4h0.5v4h-0.5zM2.5,-4h1.5v1.5h-1.5zM-4,-2.5h0.5v0.5h-0.5zM3.5,-2.5h0.5v0.5h-0.5zM-4,-2h1.5v1h-1.5zM2.5,-2h1.5v1h-1.5zM-3,-1h0.5v0.5h-0.5zM2.5,-1h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['sail', 0.27],
        ['trunk', 0.73],
      ],
      d: 'M-2.5,-4h0.5v1.5h-0.5zM2,-4h0.5v1.5h-0.5zM-5,-2.5h0.5v0.5h-0.5zM-3.5,-2.5h1.5v0.5h-1.5zM2,-2.5h1.5v0.5h-1.5zM-2.5,-2h0.5v1.5h-0.5zM2,-2h0.5v1.5h-0.5z',
    },
    {
      paint: [
        ['rock', 0.73],
        ['sail', 0.27],
      ],
      d: 'M-5.5,-1h1v0.5h-1zM4.5,-1h1v0.5h-1zM-5,-0.5h1.5v0.5h-1.5zM3.5,-0.5h1.5v0.5h-1.5zM-4,0h1v0.5h-1zM3,0h1v0.5h-1z',
    },
    {
      paint: [
        ['giwa', 0.7],
        ['shadow', 0.3],
      ],
      d: 'M-8.5,-7.5h1.5v0.5h-1.5zM7,-7.5h1.5v0.5h-1.5zM-7.5,-7h2v0.5h-2zM5,-7h2.5v0.5h-2.5zM-6,-6.5h2v0.5h-2zM1.5,-6.5h0.5v0.5h-0.5zM3.5,-6.5h2.5v0.5h-2.5zM-3.5,-6h1.5v0.5h-1.5zM2,-6h1.5v0.5h-1.5zM-2,-5.5h1.5v0.5h-1.5zM0.5,-5.5h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['giwa', 0.73],
        ['sail', 0.27],
      ],
      d: 'M-0.5,-12.5h3v0.5h-3zM-3,-12h5v0.5h-5zM-2.5,-11.5h4.5v0.5h-4.5zM-3.5,-11h5.5v0.5h-5.5zM-4,-10.5h5.5v0.5h-5.5zM-4.5,-10h6v0.5h-6zM-5.5,-9.5h7v0.5h-7zM5.5,-9.5h0.5v0.5h-0.5zM-6.5,-9h7.5v0.5h-7.5zM-8,-8.5h9v0.5h-9zM7.5,-8.5h0.5v0.5h-0.5zM-7,-8h8v0.5h-8zM6.5,-8h0.5v0.5h-0.5zM8,-8h0.5v0.5h-0.5zM-5.5,-7.5h6v0.5h-6zM-4,-7h4.5v0.5h-4.5zM-2,-6.5h2v0.5h-2zM-0.5,-6h1v0.5h-1zM-4.5,-1h0.5v0.5h-0.5zM4,-1h0.5v0.5h-0.5z',
    },
    {
      paint: 'giwa',
      d: 'M2.5,-12.5h0.5v0.5h-0.5zM2,-12h1.5v1h-1.5zM-3,-11.5h0.5v0.5h-0.5zM2,-11h2v0.5h-2zM1.5,-10.5h3v0.5h-3zM1.5,-10h3.5v0.5h-3.5zM1.5,-9.5h4v0.5h-4zM1,-9h5.5v0.5h-5.5zM1,-8.5h6.5v0.5h-6.5zM1,-8h5.5v0.5h-5.5zM0.5,-7.5h4.5v0.5h-4.5zM0.5,-7h3v0.5h-3zM0,-6.5h1.5v0.5h-1.5z',
    },
  ],
  pixels: 725,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'rock',
      d: 'M1,-15h2.5v0.5h-2.5zM-2.5,-14.5h6v0.5h-6zM-3,-14h3v0.5h-3zM-3,-13.5h0.5v0.5h-0.5zM-8,-9.5h1v0.5h-1zM7.5,-9.5h0.5v0.5h-0.5zM-7,-9h1v0.5h-1zM-5.5,-8.5h0.5v0.5h-0.5zM-0.5,-7h0.5v0.5h-0.5zM-1,-5h2v0.5h-2zM-2,-4.5h4v0.5h-4zM-1.5,-4h3v4h-3zM-5.5,-2.5h0.5v0.5h-0.5zM5,-2.5h1v0.5h-1zM-6.5,-2h1.5v0.5h-1.5zM5,-2h2v0.5h-2zM-7.5,-1.5h2.5v0.5h-2.5zM5,-1.5h3v0.5h-3zM-7,-1h1.5v0.5h-1.5zM5.5,-1h2v0.5h-2zM-6,-0.5h1v0.5h-1zM-3.5,-0.5h1v0.5h-1zM2.5,-0.5h1v0.5h-1zM5,-0.5h1.5v0.5h-1.5zM-5,0h1v0.5h-1zM-3,0h6v0.5h-6zM4,0h1.5v0.5h-1.5zM-4,0.5h8v0.5h-8zM-3,1h6v0.5h-6zM-2,1.5h4v0.5h-4zM-1,2h2v0.5h-2z',
    },
    {
      paint: [
        ['rock', 0.7],
        ['shadow', 0.3],
      ],
      d: 'M7,-9.5h0.5v0.5h-0.5zM-7.5,-9h0.5v0.5h-0.5zM5.5,-9h1.5v0.5h-1.5zM-6,-8.5h0.5v0.5h-0.5zM-5,-8.5h0.5v0.5h-0.5zM4.5,-8.5h1v0.5h-1zM-4.5,-8h1.5v0.5h-1.5zM3,-8h1v0.5h-1zM-3,-7.5h1.5v0.5h-1.5zM1.5,-7.5h1v0.5h-1zM-1.5,-7h1v0.5h-1zM0,-7h1v0.5h-1zM4.5,-2.5h0.5v1.5h-0.5zM-5,-2h0.5v1h-0.5zM-7.5,-1h0.5v0.5h-0.5zM-4,-1h1v0.5h-1zM3,-1h1v0.5h-1zM7.5,-1h0.5v0.5h-0.5zM-7.5,-0.5h1.5v0.5h-1.5zM-2.5,-0.5h0.5v0.5h-0.5zM2,-0.5h0.5v0.5h-0.5zM6.5,-0.5h1.5v0.5h-1.5zM-7.5,0h2.5v0.5h-2.5zM5.5,0h2.5v0.5h-2.5zM-6.5,0.5h2.5v0.5h-2.5zM4,0.5h3v0.5h-3zM-5.5,1h2.5v0.5h-2.5zM3,1h3v0.5h-3zM-4.5,1.5h2.5v0.5h-2.5zM2,1.5h3v0.5h-3zM-3.5,2h2.5v0.5h-2.5zM1,2h2.5v0.5h-2.5zM-2.5,2.5h5v0.5h-5zM-1.5,3h3v0.5h-3zM-0.5,3.5h1v0.5h-1z',
    },
    {
      paint: 'trunk',
      d: 'M-5,-7.5h0.5v0.5h-0.5zM4.5,-7.5h0.5v0.5h-0.5zM-5,-7h1.5v2h-1.5zM3.5,-7h1.5v2h-1.5zM-5,-5h1v2.5h-1zM4,-5h1v2.5h-1zM-4.5,-2.5h0.5v1.5h-0.5zM4,-2.5h0.5v1.5h-0.5z',
    },
    {
      paint: [
        ['shadow', 0.3],
        ['trunk', 0.7],
      ],
      d: 'M-4.5,-7.5h0.5v0.5h-0.5zM4,-7.5h0.5v0.5h-0.5zM-3.5,-7h1v0.5h-1zM2.5,-7h1v0.5h-1zM-2.5,-6.5h1.5v0.5h-1.5zM1,-6.5h1.5v0.5h-1.5zM-1.5,-6h3v0.5h-3zM-0.5,-5.5h1v0.5h-1zM-4,-5h0.5v0.5h-0.5zM3.5,-5h0.5v0.5h-0.5z',
    },
    {
      paint: 'roofA',
      d: 'M-3.5,-5h0.5v0.5h-0.5zM3,-5h0.5v0.5h-0.5zM-4,-4.5h2v0.5h-2zM2,-4.5h2v0.5h-2zM-4,-4h1.5v1.5h-1.5zM-2,-4h0.5v4h-0.5zM1.5,-4h0.5v4h-0.5zM2.5,-4h1.5v1.5h-1.5zM-4,-2.5h0.5v0.5h-0.5zM3.5,-2.5h0.5v0.5h-0.5zM-4,-2h1.5v1h-1.5zM2.5,-2h1.5v1h-1.5zM-3,-1h0.5v0.5h-0.5zM2.5,-1h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['sail', 0.27],
        ['trunk', 0.73],
      ],
      d: 'M-2.5,-4h0.5v1.5h-0.5zM2,-4h0.5v1.5h-0.5zM-5,-2.5h0.5v0.5h-0.5zM-3.5,-2.5h1.5v0.5h-1.5zM2,-2.5h1.5v0.5h-1.5zM-2.5,-2h0.5v1.5h-0.5zM2,-2h0.5v1.5h-0.5z',
    },
    {
      paint: [
        ['rock', 0.73],
        ['sail', 0.27],
      ],
      d: 'M-5.5,-1h1v0.5h-1zM4.5,-1h1v0.5h-1zM-5,-0.5h1.5v0.5h-1.5zM3.5,-0.5h1.5v0.5h-1.5zM-4,0h1v0.5h-1zM3,0h1v0.5h-1z',
    },
    {
      paint: [
        ['giwa', 0.7],
        ['shadow', 0.3],
      ],
      d: 'M-8,-9h0.5v0.5h-0.5zM7,-9h1v0.5h-1zM-8,-8.5h2v0.5h-2zM5.5,-8.5h2.5v0.5h-2.5zM-6.5,-8h2v0.5h-2zM4,-8h2.5v0.5h-2.5zM-4,-7.5h1v0.5h-1zM2.5,-7.5h1.5v0.5h-1.5zM-2.5,-7h1v0.5h-1zM1,-7h1.5v0.5h-1.5zM-1,-6.5h2v0.5h-2z',
    },
    {
      paint: [
        ['giwa', 0.73],
        ['sail', 0.27],
      ],
      d: 'M0,-14h2v0.5h-2zM-2.5,-13.5h4.5v1h-4.5zM-3,-12.5h4.5v1h-4.5zM-4,-11.5h5.5v0.5h-5.5zM-4.5,-11h6v0.5h-6zM-5.5,-10.5h6.5v0.5h-6.5zM-6.5,-10h7.5v0.5h-7.5zM-7,-9.5h8v0.5h-8zM-6,-9h6.5v0.5h-6.5zM-4.5,-8.5h5v0.5h-5zM4,-8.5h0.5v0.5h-0.5zM-3,-8h3v0.5h-3zM2.5,-8h0.5v0.5h-0.5zM-1.5,-7.5h1.5v0.5h-1.5zM1,-7.5h0.5v0.5h-0.5zM-4.5,-1h0.5v0.5h-0.5zM4,-1h0.5v0.5h-0.5z',
    },
    {
      paint: 'giwa',
      d: 'M2,-14h1v1h-1zM-3,-13h0.5v0.5h-0.5zM2,-13h1.5v0.5h-1.5zM-3.5,-12.5h0.5v1h-0.5zM1.5,-12.5h2v0.5h-2zM1.5,-12h2.5v0.5h-2.5zM1.5,-11.5h3v0.5h-3zM1.5,-11h3.5v0.5h-3.5zM1,-10.5h4.5v0.5h-4.5zM1,-10h5.5v0.5h-5.5zM1,-9.5h6v0.5h-6zM0.5,-9h5v0.5h-5zM0.5,-8.5h3.5v0.5h-3.5zM0,-8h2.5v0.5h-2.5zM0,-7.5h1v0.5h-1z',
    },
  ],
  pixels: 732,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'rock',
      d: 'M3,-13h0.5v0.5h-0.5zM-1,-12.5h4.5v0.5h-4.5zM-3.5,-12h5v0.5h-5zM-3.5,-11.5h1.5v0.5h-1.5zM-9.5,-8h1v0.5h-1zM8.5,-8h1v0.5h-1zM-8,-7.5h1v0.5h-1zM-6.5,-7h1.5v0.5h-1.5zM-0.5,-5.5h0.5v0.5h-0.5zM-2,-4.5h0.5v0.5h-0.5zM1.5,-4.5h0.5v0.5h-0.5zM-1.5,-4h1v0.5h-1zM0.5,-4h1v0.5h-1zM-1.5,-3.5h3v3.5h-3zM-7.5,-1.5h2v0.5h-2zM5.5,-1.5h2.5v0.5h-2.5zM-7,-1h1.5v0.5h-1.5zM5.5,-1h2v0.5h-2zM-6,-0.5h1v0.5h-1zM-3.5,-0.5h1v0.5h-1zM2.5,-0.5h1v0.5h-1zM5,-0.5h1.5v0.5h-1.5zM-5,0h1v0.5h-1zM-3,0h6v0.5h-6zM4,0h1.5v0.5h-1.5zM-4,0.5h8v0.5h-8zM-3,1h6v0.5h-6zM-2,1.5h4v0.5h-4zM-1,2h2v0.5h-2z',
    },
    {
      paint: [
        ['rock', 0.7],
        ['shadow', 0.3],
      ],
      d: 'M-8.5,-7.5h0.5v0.5h-0.5zM6.5,-7.5h2v0.5h-2zM-7,-7h0.5v0.5h-0.5zM5,-7h1.5v0.5h-1.5zM-5.5,-6.5h2v0.5h-2zM3.5,-6.5h1.5v0.5h-1.5zM-3.5,-6h2v0.5h-2zM1.5,-6h1.5v0.5h-1.5zM-1.5,-5.5h1v0.5h-1zM0,-5.5h1.5v0.5h-1.5zM-1.5,-4.5h0.5v0.5h-0.5zM1,-4.5h0.5v0.5h-0.5zM-0.5,-4h1v0.5h-1zM4.5,-2.5h0.5v1.5h-0.5zM-5,-2h0.5v1h-0.5zM-7.5,-1h0.5v0.5h-0.5zM-4,-1h1v0.5h-1zM3,-1h1v0.5h-1zM7.5,-1h0.5v0.5h-0.5zM-7.5,-0.5h1.5v0.5h-1.5zM-2.5,-0.5h0.5v0.5h-0.5zM2,-0.5h0.5v0.5h-0.5zM6.5,-0.5h1.5v0.5h-1.5zM-7.5,0h2.5v0.5h-2.5zM5.5,0h2.5v0.5h-2.5zM-6.5,0.5h2.5v0.5h-2.5zM4,0.5h3v0.5h-3zM-5.5,1h2.5v0.5h-2.5zM3,1h3v0.5h-3zM-4.5,1.5h2.5v0.5h-2.5zM2,1.5h3v0.5h-3zM-3.5,2h2.5v0.5h-2.5zM1,2h2.5v0.5h-2.5zM-2.5,2.5h5v0.5h-5zM-1.5,3h3v0.5h-3zM-0.5,3.5h1v0.5h-1z',
    },
    {
      paint: 'trunk',
      d: 'M-5,-5.5h1.5v0.5h-1.5zM3.5,-5.5h1.5v0.5h-1.5zM-5,-5h1v2.5h-1zM4,-5h1v2.5h-1zM-4.5,-2.5h0.5v1.5h-0.5zM4,-2.5h0.5v1.5h-0.5z',
    },
    {
      paint: [
        ['shadow', 0.3],
        ['trunk', 0.7],
      ],
      d: 'M-4,-5h0.5v0.5h-0.5zM-2.5,-5h1v0.5h-1zM1.5,-5h1v0.5h-1zM3.5,-5h0.5v0.5h-0.5zM-1,-4.5h2v0.5h-2z',
    },
    {
      paint: 'roofA',
      d: 'M-3.5,-5h0.5v0.5h-0.5zM3,-5h0.5v0.5h-0.5zM-4,-4.5h2v0.5h-2zM2,-4.5h2v0.5h-2zM-4,-4h1.5v1.5h-1.5zM-2,-4h0.5v4h-0.5zM1.5,-4h0.5v4h-0.5zM2.5,-4h1.5v1.5h-1.5zM-4,-2.5h0.5v0.5h-0.5zM3.5,-2.5h0.5v0.5h-0.5zM-4,-2h1.5v1h-1.5zM2.5,-2h1.5v1h-1.5zM-3,-1h0.5v0.5h-0.5zM2.5,-1h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['sail', 0.27],
        ['trunk', 0.73],
      ],
      d: 'M-2.5,-4h0.5v1.5h-0.5zM2,-4h0.5v1.5h-0.5zM-5,-2.5h0.5v0.5h-0.5zM-3.5,-2.5h1.5v0.5h-1.5zM2,-2.5h1.5v0.5h-1.5zM-2.5,-2h0.5v1.5h-0.5zM2,-2h0.5v1.5h-0.5z',
    },
    {
      paint: [
        ['rock', 0.73],
        ['sail', 0.27],
      ],
      d: 'M6.5,-2h0.5v0.5h-0.5zM-5.5,-1.5h0.5v0.5h-0.5zM5,-1.5h0.5v0.5h-0.5zM-5.5,-1h1v0.5h-1zM4.5,-1h1v0.5h-1zM-5,-0.5h1.5v0.5h-1.5zM3.5,-0.5h1.5v0.5h-1.5zM-4,0h1v0.5h-1zM3,0h1v0.5h-1z',
    },
    {
      paint: 'wall',
      d: 'M-8.5,-5h1v0.5h-1zM7.5,-5h1v0.5h-1zM-8.5,-4.5h2.5v0.5h-2.5zM6,-4.5h2.5v0.5h-2.5zM-8.5,-4h3.5v1.5h-3.5zM5,-4h3.5v1.5h-3.5zM-8,-2.5h3v0.5h-3zM5,-2.5h3v0.5h-3zM-7,-2h2v0.5h-2zM5,-2h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['giwa', 0.7],
        ['shadow', 0.3],
      ],
      d: 'M-9.5,-7.5h1v0.5h-1zM8.5,-7.5h1v0.5h-1zM-9,-7h2v0.5h-2zM6.5,-7h2.5v0.5h-2.5zM-7.5,-6.5h2v0.5h-2zM5,-6.5h2.5v0.5h-2.5zM-5.5,-6h2v0.5h-2zM3,-6h2.5v0.5h-2.5zM-3.5,-5.5h2v0.5h-2zM1.5,-5.5h2v0.5h-2zM-1.5,-5h3v0.5h-3z',
    },
    {
      paint: [
        ['giwa', 0.73],
        ['sail', 0.27],
      ],
      d: 'M1.5,-12h1v0.5h-1zM-2,-11.5h4.5v0.5h-4.5zM-3,-11h5v0.5h-5zM-3.5,-10.5h5.5v0.5h-5.5zM-4,-10h6v0.5h-6zM-5,-9.5h6.5v0.5h-6.5zM-6,-9h7.5v0.5h-7.5zM-7,-8.5h8.5v0.5h-8.5zM-8.5,-8h9.5v0.5h-9.5zM8,-8h0.5v0.5h-0.5zM-7,-7.5h8v0.5h-8zM-5,-7h5.5v0.5h-5.5zM4.5,-7h0.5v0.5h-0.5zM-3.5,-6.5h4v0.5h-4zM3,-6.5h0.5v0.5h-0.5zM-1.5,-6h1.5v0.5h-1.5zM-4.5,-1h0.5v0.5h-0.5zM4,-1h0.5v0.5h-0.5z',
    },
    {
      paint: 'giwa',
      d: 'M2.5,-12h0.5v0.5h-0.5zM2.5,-11.5h1v0.5h-1zM2,-11h2v0.5h-2zM2,-10.5h2.5v0.5h-2.5zM2,-10h3v0.5h-3zM1.5,-9.5h4v0.5h-4zM1.5,-9h5v0.5h-5zM1.5,-8.5h6v0.5h-6zM1,-8h7v0.5h-7zM1,-7.5h5.5v0.5h-5.5zM0.5,-7h4v0.5h-4zM0.5,-6.5h2.5v0.5h-2.5zM0,-6h1.5v0.5h-1.5z',
    },
  ],
  pixels: 783,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
